import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  Slider,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material';
import './DispatchTracking.scss';
import { Icon } from '@iconify/react';
import { useForm } from 'react-hook-form';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import GoogleMap from '../../../../../common/components/maps/googlemap/GoogleMapTilt';

const DispatchTracking = () => {
  const [filter, setFilter] = useState('');
  const [activeStep, setActiveStep] = useState<any>();
  const [open, setOpen] = useState<boolean>(false);
  const { control } = useForm();
  const navigate = useNavigate();

  const staticData = {
    trackingId: '#6024',
    status: 'Delivered',
    packageData: '25 February 2025',
    time: '18:00 PM',
    totalItem: '2 items',
    loads: [
      {
        loadId: '#6041',
        loadTime: '10:40am'
      },
      {
        loadId: '#6042',
        loadTime: '11:40am'
      },
      {
        loadId: '#6043',
        loadTime: '10:40am'
      },
      {
        loadId: '#6041',
        loadTime: '10:40am'
      },
      {
        loadId: '#6042',
        loadTime: '11:40am'
      },
      {
        loadId: '#6043',
        loadTime: '10:40am'
      },
      {
        loadId: '#6041',
        loadTime: '10:40am'
      },
      {
        loadId: '#6042',
        loadTime: '11:40am'
      },
      {
        loadId: '#6043',
        loadTime: '10:40am'
      }
    ]
  };

  const steps = staticData.loads.map(load => ({
    label: load.loadId,
    description: load.loadTime
  }));

  const handleFilterChange = (event: any) => {
    setFilter(event);
  };

  const handleBack = () => {
    navigate('/dispatch');
  };
  return (
    <Box className='tracking-container'>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='h6' className='section-one-text'>
          Loads
        </Typography>
        <Button
          variant='contained'
          endIcon={<Icon icon='mingcute:back-line' width='16' height='16' />}
          className='add-tracking-button'
          onClick={handleBack}
        >
          Go back
        </Button>
      </Box>
      <Grid container gap={0.5} sx={{ mt: 2, overflowY: 'scroll', height: '100vh' }}>
        <Grid item xs={12} sm={12} md={4.5} lg={3} className='tracking-grid'>
          <Box>
            <CustomTextField
              name='search'
              control={control}
              id='filter-input'
              placeholder='Search...'
              value={filter}
              variant='outlined'
              icon={<SearchOutlinedIcon sx={{ color: 'grey' }} />}
              onChangeCallback={(e: any) => handleFilterChange(e)}
            />
          </Box>
          <Box sx={{ display: 'flex', padding: '10px' }}>
            <Icon
              icon='mynaui:truck'
              className={
                staticData.status === 'Delivered'
                  ? 'truck-icon-green'
                  : staticData.status === 'OnGoing'
                  ? 'truck-icon-yellow'
                  : staticData.status === 'Pending'
                  ? 'truck-icon-red'
                  : 'truck-icon-blue'
              }
            />
            <Box>
              <Typography className='tracking-text'>Tracking ID</Typography>
              <Typography>{staticData.trackingId}</Typography>
            </Box>
            <Typography
              className={
                // staticData.status === 'Delivered'
                //   ? 'delivered-green'
                //   : staticData.status === 'In transit'
                //   ? 'delivered-yellow'
                //   : 'delivered-red'
                staticData.status === 'Delivered'
                  ? 'delivered-green'
                  : staticData.status === 'OnGoing'
                  ? 'delivered-yellow'
                  : staticData.status === 'Pending'
                  ? 'delivered-red'
                  : 'delivered-blue'
              }
            >
              {staticData.status}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography className='typo-details'>Package dispatched on</Typography>
            <Typography className='typo-details-bold'>
              {staticData.packageData}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
            <Typography className='typo-details'>Time</Typography>
            <Typography className='typo-details-bold'>{staticData.time}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
            <Typography className='typo-details'>Total item</Typography>
            <Typography className='typo-details-bold'>{staticData.totalItem}</Typography>
          </Box>
          <Box
            sx={{
              mt: 1,
              height: '53vh',
              scrollbarWidth: 'none',
              overflowY: 'scroll'
            }}
          >
            <Stepper
              activeStep={activeStep}
              orientation='vertical'
              sx={{
                cursor: 'pointer'
              }}
            >
              {steps.map((step, index) => (
                <Step key={index} expanded={true}>
                  <StepLabel
                    icon={
                      <Icon
                        icon='radix-icons:dot-filled'
                        width='20'
                        height='20'
                        style={{
                          marginLeft: '3px',
                          color: activeStep === step.label ? '#00a550' : 'grey'
                        }}
                      />
                    }
                    onClick={() => setActiveStep(step.label)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Typography className='typo-details-bold'>{step.label}</Typography>
                  </StepLabel>
                  <StepContent onClick={() => setActiveStep(step.label)}>
                    <Typography className='typo-details'>{step.description}</Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={7} lg={8.9} className='tracking-grid'>
          <GoogleMap>
            <Box className='tracking-card'>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex' }}>
                  <Icon
                    icon='mingcute:location-line'
                    width='25'
                    height='25'
                    className='tracking-icon'
                  />
                  <Typography className='tracking-card-text'>
                    Live truck tracking
                  </Typography>
                </Box>
                <Icon
                  icon={open ? 'ri:close-line' : 'solar:alt-arrow-up-outline'}
                  width='25'
                  height='25'
                  onClick={() => setOpen((prev: any) => !prev)}
                  className='tracking-toggle-icon'
                />
              </Box>
              <Collapse in={open}>
                <Grid container gap={0.5} className='tracking-collapse'>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8.9}
                    lg={8.9}
                    className='tracking-section'
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', mt: 0.2 }}>
                        <Typography className='typo-card-details'>
                          Tracking ID:
                        </Typography>
                        <Typography className='tracking-id'>#C024</Typography>
                      </Box>
                      <Box sx={{ display: 'flex' }}>
                        <Typography className='typo-ship'>Truck Status:</Typography>
                        <Typography className='delivered-orange'>On going</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Box>
                        <Typography className='typo-card-details'>From</Typography>
                        <Typography className='typo-card-det'>
                          Jakarta, Indonesia
                        </Typography>
                      </Box>
                      <Box>
                        <Typography className='typo-card-details'>To</Typography>
                        <Typography className='typo-card-det'>
                          Bandung, Indonesia
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Slider
                        defaultValue={50}
                        aria-label='Default'
                        valueLabelDisplay='auto'
                        disabled
                      />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Box>
                        <Typography className='typo-card-details'>
                          Package dispatched
                        </Typography>
                        <Typography className='typo-card-det'>
                          February 19,2025 . 18.49 PM
                        </Typography>
                      </Box>
                      <Box>
                        <Typography className='typo-card-details'>
                          Est. package arrival
                        </Typography>
                        <Typography className='typo-card-det'>
                          February 19,2025 . 18.49 PM
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} className='tracking-section'>
                    <Box sx={{ mt: 1.5 }}>
                      <Typography className='typo-details'>Distance</Typography>
                      <Typography>153 KM</Typography>
                      <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                      <Typography className='typo-details'>Est. delivery time</Typography>
                      <Typography>2 hours 22 minutes</Typography>
                      <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                      <Typography className='typo-details'>Total weight</Typography>
                      <Typography>26.89 kg</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Collapse>
            </Box>
          </GoogleMap>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DispatchTracking;
